import React, { useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons'
import { TileStatus } from './TileStatus'
import { FormStatus } from '@/api/brokers/v1/brokers_pb'

import './Tile.css'

interface TileProps {
	name: string
	city: string
	buyer: string
	status: FormStatus | undefined
	onClick?: () => void
	onCopyLink?: () => void
	onResendEmail?: () => void
}

export function Tile(props: TileProps) {
	const [menuOpen, setMenuOpen] = useState(false)
	const menuRef = useRef<HTMLDivElement>(null)

	useEffect(() => {
		if (!menuOpen) return
		const handler = (event: MouseEvent) => {
			if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
				setMenuOpen(false)
			}
		}
		document.addEventListener('mousedown', handler)
		return () => document.removeEventListener('mousedown', handler)
	}, [menuOpen])

	const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
		if (!props.onClick) return
		if (event.key !== 'Enter' && event.key !== ' ') return
		event.preventDefault()
		props.onClick()
	}

	return (
		<div
			className={'tile' + (props.onClick ? ' tileClickable' : '')}
			onClick={props.onClick}
			onKeyDown={handleKeyDown}
			role={props.onClick ? 'button' : undefined}
			tabIndex={props.onClick ? 0 : undefined}
		>
			<div className='tileHeader'>
				<div className='tileName'>{props.name}</div>
				<div className='tileCity'>{props.city}</div>
			</div>
			<div className='tileFooter'>
				<div className='tileBuyer'>{props.buyer}</div>
				<TileStatus status={props.status} />
			</div>
			{(props.onCopyLink || props.onResendEmail) && (
				<div className='tileMenuContainer' ref={menuRef}>
					<button
						className='tileMenuButton'
						type='button'
						aria-label='Actions'
						onClick={e => { e.stopPropagation(); setMenuOpen(o => !o) }}
					>
						<FontAwesomeIcon icon={faEllipsisVertical} />
					</button>
					{menuOpen && (
						<div className='tileMenu'>
							{props.onCopyLink && (
								<button
									type='button'
									onClick={e => { e.stopPropagation(); props.onCopyLink!(); setMenuOpen(false) }}
								>
									Copier le lien acquéreur
								</button>
							)}
							{props.onResendEmail && (
								<button
									type='button'
									onClick={e => { e.stopPropagation(); props.onResendEmail!(); setMenuOpen(false) }}
								>
									Renvoyer le lien par email
								</button>
							)}
						</div>
					)}
				</div>
			)}
		</div>
	)
}
